import {
  AnimationLayout,
  AuthGuard,
  DashboardLayout,
  AdminLayout,
} from '@app/components';
import {
  Contacts,
  CustomerView,
  Dashboard,
  ForgotPassword,
  ImportFromFile,
  IntegrationsCRM,
  IntegrationsReviews,
  Lists,
  Login,
  NewBusiness,
  NewPassword,
  ProfileSettings,
  SelectBusiness,
  Settings,
  SignUp,
  SignUpConfirmation,
  TrialSignUpConfirmation,
  TrialEnding,
  TrialEndingLastDay,
  TrialExpired,
  ValidateEmail,
  Welcome,
  WelcomeExisting,
  ListView,
  AnalyticsRatings,
  AnalyticsCampaigns,
  YourCurrentPlan,
  FrequentQuestions,
  TermsOfService,
  CampaignView,
  Payment,
  Unsubscribe,
  LeaveFeedback,
  AdminDashboard,
  AdminUsers,
  AdminPlans,
  AdminActivityLogs,
  AdminBusinesses,
  MemberProfile,
  AdminBusinessMembers,
  AdminErrorLogs,
  ErrorLogDetail,
  AdminAuditLogs,
  AuditLogDetail,
  AdminLogs,
} from '@app/pages';
import { TrialWelcome } from '@app/pages/TrialWelcome';
import { TrialPayment } from '@app/pages/TrialPayment';
import { SubscriptionRenewal } from '@app/pages/SubscriptionRenewal/SubscriptionRenewal';
import { AnalyticsRatingsPlatform } from '@app/pages/AnalyticsRatingsPlatform/AnalyticsRatingsPlatform';
import { Automations } from '@app/pages/Automations/Automations';
import { Campaigns } from '@app/pages/Campaigns/Campaigns';
import { CreateCampaign } from '@app/pages/CreateCampaign/CreateCampaign';
import { LeaveReview } from '@app/pages/LeaveReview/LeaveReview';
import { LeaveReviewBad } from '@app/pages/LeaveReview/LeaveReviewBad';
import { LeaveReviewGood } from '@app/pages/LeaveReview/LeaveReviewGood';
import { Onboarding } from '@app/pages/Onboarding/Onboarding';
import { RatingsFeedback } from '@app/pages/Ratings/RatingsFeedback';
import { RatingsReviews } from '@app/pages/RatingsReviews/RatingsReviews';
import { createBrowserRouter } from 'react-router-dom';
import { CreateCampaign as CreateCampaignRoutes } from '@app/utils/consts';
import { CreateAutomation as CreateAutomationRoutes } from '@app/utils/consts';
import { PrivacyPolicy } from '@app/pages/PrivacyPolicy/PrivacyPolicy';
import { ComingSoon } from '@app/pages/ComingSoon/ComingSoon';
import { AcceptInvite } from '@app/pages/AcceptInvite';
import { Documentation } from '@app/pages/Documentation/Documentation';
import { GettingStarted } from '@app/pages/Documentation/articles/GettingStarted';
import { NavigatingDashboard } from '@app/pages/Documentation/articles/NavigatingDashboard';
import { ConnectGoogle } from '@app/pages/Documentation/articles/ConnectGoogle';
import { AccountRoles } from '@app/pages/Documentation/articles/AccountRoles';
import { FindHelp } from '@app/pages/Documentation/articles/FindHelp';
import { FreeSignUpConfirmation } from '@app/pages/FreeSignUpConfirmation';
import {AutomationView} from "@app/pages/Automations/AutomationView.tsx";
import {CreateAutomation} from "@app/pages/CreateAutomation/CreateAutomation.tsx";
import {AdminReviewsSyncs} from "@app/pages/Admin/AdminReviewsSyncs.tsx";

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AnimationLayout />,

    children: [
      {
        path: '/login',
        element: <Login />,
        handle: {
          crumb: () => 'Login',
        },
      },
      {
        path: '/validate-email/:token',
        element: <ValidateEmail />,
        handle: {
          crumb: () => 'Validate Email',
        },
      },
      {
        path: '/sign-up',
        element: <SignUp />,
        handle: {
          crumb: () => 'Sign Up',
        },
      },
      {
        path: '/welcome',
        element: <Welcome />,
        handle: {
          crumb: () => 'Welcome',
        },
      },
      {
        path: '/welcome-existing',
        element: <WelcomeExisting />,
        handle: {
          crumb: () => 'Choose Plan',
        },
      },
      {
        path: '/payment',
        element: <Payment />,
        handle: {
          crumb: () => 'Payment',
        },
      },
      {
        path: '/forgot-password',
        element: <ForgotPassword />,
        handle: {
          crumb: () => 'Forgot Password',
        },
      },
      {
        path: '/reset-password/:token',
        element: <NewPassword />,
        handle: {
          crumb: () => 'Reset Password',
        },
      },
      {
        path: '/leave-review/:requestId',
        element: <LeaveReview />,
        handle: {
          crumb: () => 'Leave Review',
        },
      },
      {
        path: '/leave-review/:requestId/need-improvement',
        element: <LeaveReviewBad />,
        handle: {
          crumb: () => 'Leave Review',
        },
      },
      {
        path: '/leave-review/:requestId/thank-you',
        element: <LeaveReviewGood />,
        handle: {
          crumb: () => 'Leave Review',
        },
      },
      {
        path: '/accept-invite/:token',
        element: <AcceptInvite />,
        handle: {
          crumb: () => 'Accept Invitation',
        },
      },
        {
          path: '/unsubscribe/:token',
          element: <Unsubscribe />,
          handle: {
            crumb: () => 'Unsubscribe',
          },
        },
        // {
        //   path: '/unsubscribe/:businessId/:customerId',
        //   element: <Unsubscribe />,
        //   handle: {
        //     crumb: () => 'Unsubscribe',
        //   },
        // },
      {
        element: <AuthGuard />,
        children: [
          {
            path: '/select-business',
            element: <SelectBusiness />,
            handle: {
              crumb: () => 'Select Business',
            },
          },
          {
            path: '/select-business/create-new',
            element: <NewBusiness />,
            handle: {
              crumb: () => 'Create new Business',
            },
          },
          {
            element: <DashboardLayout />,
            children: [
              {
                path: '/onboarding',
                element: <Onboarding />,
                handle: {
                  crumb: () => 'Onboarding',
                },
              },
              {
                path: '/automations',
                element: <Automations />,
                handle: {
                  crumb: () => 'Automations',
                },
              },
              {
                path: '/automations/:id',
                element: <AutomationView />,
                handle: {
                  crumb: () => 'Automations -> View Automation',
                },
              },
              {
                path: '/automations/create/settings',
                element: (
                    <CreateAutomation page={CreateAutomationRoutes.SETTINGS} />
                ),
                handle: {
                  crumb: () => 'Automations > Create Automation > Settings',
                },
              },
              {
                path: '/automations/create/automation',
                element: (
                    <CreateAutomation page={CreateAutomationRoutes.AUTOMATION} />
                ),
                handle: {
                  crumb: () => 'Automations > Create Automation > Automation',
                },
              },
              {
                path: '/campaigns',
                element: <Campaigns />,
                handle: {
                  crumb: () => 'Campaigns',
                },
              },
              {
                path: '/campaigns/:id',
                element: <CampaignView />,
                handle: {
                  crumb: () => 'Campaigns -> View Campaign',
                },
              },
              {
                path: '/campaigns/create/settings',
                element: (
                  <CreateCampaign page={CreateCampaignRoutes.SETTINGS} />
                ),
                handle: {
                  crumb: () => 'Campaigns > Create Campaign > Settings',
                },
              },
              {
                path: '/campaigns/create/customers',
                element: (
                  <CreateCampaign page={CreateCampaignRoutes.CUSTOMERS} />
                ),
                handle: {
                  crumb: () => 'Campaigns > Create Campaign > Customers',
                },
              },
              {
                path: '/campaigns/create/campaign',
                element: (
                  <CreateCampaign page={CreateCampaignRoutes.CAMPAIGN} />
                ),
                handle: {
                  crumb: () => 'Campaigns > Create Campaign > Campaign',
                },
              },
              {
                path: '/campaigns/automation',
                element: (
                  <CreateCampaign page={CreateCampaignRoutes.CAMPAIGN} />
                ),
                handle: {
                  crumb: () => 'Campaigns > Create Automation',
                },
              },
              {
                path: '/ratings',
                element: <RatingsFeedback />,
                handle: {
                  crumb: () => 'Ratings',
                },
              },
              {
                path: '/ratings/reviews',
                element: <RatingsReviews />,
                handle: {
                  crumb: () => 'Reviews',
                },
              },
              {
                path: '/ratings/feedbacks',
                element: <RatingsFeedback />,
                handle: {
                  crumb: () => 'Ratings > Feedbacks',
                },
              },
              {
                index: true,
                path: '/',
                element: <Dashboard />,
                handle: {
                  crumb: () => 'Dashboard',
                },
              },
              {
                index: true,
                path: '/customers/contacts',
                element: <Contacts />,
                handle: {
                  crumb: () => 'Contacts',
                },
              },
              {
                index: true,
                path: '/customers/contacts/:id',
                element: <CustomerView />,
                handle: {
                  crumb: () => 'Contacts',
                },
              },
              {
                index: true,
                path: '/customers/contacts/import-file',
                element: <ImportFromFile />,
                handle: {
                  crumb: () => 'Customers > Import from file',
                },
              },
              {
                index: true,
                path: '/analytics/ratings',
                element: <AnalyticsRatings />,
                handle: {
                  crumb: () => 'Analytics > Ratings',
                },
              },
              {
                index: true,
                path: '/analytics/ratings/platforms',
                element: <AnalyticsRatingsPlatform />,
                handle: {
                  crumb: () => 'Analytics > Ratings > Platforms',
                },
              },
              {
                index: true,
                path: '/analytics/campaigns',
                element: <AnalyticsCampaigns />,
                handle: {
                  crumb: () => 'Analytics > Campaigns',
                },
              },

              {
                index: true,
                path: '/customers/lists',
                element: <Lists />,
                handle: {
                  crumb: () => 'Customers > Lists',
                },
              },
              {
                index: true,
                path: '/customers/lists/:id',
                element: <ListView />,
                handle: {
                  crumb: () => 'Customers > Lists',
                },
              },
              {
                path: '/integrations',
                element: <Settings />,
                handle: {
                  crumb: () => 'Integrations',
                },
              },
              {
                path: '/integrations/reviews',
                element: <IntegrationsReviews />,
                handle: {
                  crumb: () => 'Integrations > Reviews',
                },
              },
              {
                path: '/integrations/crm',
                element: <IntegrationsCRM />,
                handle: {
                  crumb: () => 'Integrations > CRM Connection',
                },
              },
              {
                path: '/settings',
                element: <Settings />,
                handle: {
                  crumb: () => 'Settings',
                },
              },
              {
                path: '/settings/members/:memberId',
                element: <MemberProfile />,
                handle: {
                  crumb: () => 'Settings',
                },
              },
              {
                index: true,
                path: '/settings/plan/details',
                element: <YourCurrentPlan />,
                handle: {
                  crumb: () => 'Settings > Plan Details',
                },
              },
              {
                path: '/profile',
                element: <ProfileSettings />,
                handle: {
                  crumb: () => 'Profile Settings',
                },
              },
              {
                path: '/documentation',
                element: <Documentation />,
                handle: {
                  crumb: () => 'Documentation',
                },
              },
              {
                path: '/documentation/getting-started',
                element: <GettingStarted />,
                handle: {
                  crumb: () => 'Documentation > Getting Started',
                },
              },
              {
                path: '/documentation/dashboard',
                element: <NavigatingDashboard />,
                handle: {
                  crumb: () => 'Documentation > Dashboard',
                },
              },
              {
                path: '/documentation/connect-google',
                element: <ConnectGoogle />,
                handle: {
                  crumb: () => 'Documentation > Connect Google',
                },
              },
              {
                path: '/documentation/account-roles',
                element: <AccountRoles />,
                handle: {
                  crumb: () => 'Documentation > Account Roles',
                },
              },
              {
                path: '/documentation/help',
                element: <FindHelp />,
                handle: {
                  crumb: () => 'Documentation > Help',
                },
              },
            ],
          },
        ],
      },
      {
        path: '/faq',
        element: <FrequentQuestions />,
        handle: {
          crumb: () => 'FAQ',
        },
      },
      {
        path: '/terms-of-service',
        element: <TermsOfService />,
        handle: {
          crumb: () => 'Terms of Service',
        },
      },
      {
        path: '/privacy-policy',
        element: <PrivacyPolicy />,
        handle: {
          crumb: () => 'Privacy Policy',
        },
      },
      {
        path: '/coming-soon',
        element: <ComingSoon />,
        handle: {
          crumb: () => 'Coming Soon',
        },
      },
      {
        path: '/sign-up-confirmation',
        element: <SignUpConfirmation />,
        handle: {
          crumb: () => 'Sign Up Confirmation',
        },
      },
      {
        path: '/trial-sign-up-confirmation',
        element: <TrialSignUpConfirmation />,
        handle: {
          crumb: () => 'Trial Sign Up Confirmation',
        },
      },
      {
        path: '/free-sign-up-confirmation',
        element: <FreeSignUpConfirmation />,
        handle: {
          crumb: () => 'Free Sign Up Confirmation',
        },
      },
      {
        path: '/trial-ending',
        element: <TrialEnding />,
        handle: {
          crumb: () => 'Trial Ending',
        },
      },
      {
        path: '/trial-ending-last-day',
        element: <TrialEndingLastDay />,
        handle: {
          crumb: () => 'Trial Ending Last Day',
        },
      },
      {
        path: '/trial-expired',
        element: <TrialExpired />,
        handle: {
          crumb: () => 'Trial Expired',
        },
      },
      {
        path: '/trial-welcome',
        element: <TrialWelcome />,
        handle: {
          crumb: () => 'Choose Plan',
        },
      },
      {
        path: '/trial-payment',
        element: <TrialPayment />,
        handle: {
          crumb: () => 'Payment',
        },
      },
      {
        path: '/subscription-renewal',
        element: <SubscriptionRenewal />,
        handle: {
          crumb: () => 'Renew Subscription',
        },
      },
      {
        path: '/leave-feedback',
        element: <LeaveFeedback />,
        handle: {
          crumb: () => 'Leave Feedback',
        },
      },
      // Admin routes
      {
        path: '/admin',
        element: <AuthGuard />,
        children: [
          {
            element: <AdminLayout />,
            children: [
              {
                index: true,
                element: <AdminDashboard />,
                handle: {
                  crumb: () => 'Admin Dashboard',
                },
              },
              {
                path: 'users',
                element: <AdminUsers />,
                handle: {
                  crumb: () => 'Admin > Users',
                },
              },
              {
                path: 'businesses',
                element: <AdminBusinesses />,
                handle: {
                  crumb: () => 'Admin > Businesses',
                },
              },
              {
                path: 'businesses/:id/members',
                element: <AdminBusinessMembers />,
                handle: {
                  crumb: () => 'Admin > Business Members',
                },
              },
              {
                path: 'plans',
                element: <AdminPlans />,
                handle: {
                  crumb: () => 'Admin > Plans',
                },
              },
              {
                path: 'logs',
                element: <AdminLogs />,
                handle: {
                  crumb: () => 'Admin > Logs',
                },
                children: [
                  {
                    path: 'activity',
                    element: <AdminActivityLogs />,
                    handle: {
                      crumb: () => 'Admin > Logs > Activity Logs',
                    },
                  },
                  {
                    path: 'error',
                    element: <AdminErrorLogs />,
                    handle: {
                      crumb: () => 'Admin > Logs > Error Logs',
                    },
                  },
                  {
                    path: 'error/:id',
                    element: <ErrorLogDetail />,
                    handle: {
                      crumb: () => 'Admin > Logs > Error Log Details',
                    },
                  },
                  {
                    path: 'audit',
                    element: <AdminAuditLogs />,
                    handle: {
                      crumb: () => 'Admin > Logs > Audit Logs',
                    },
                  },
                  {
                    path: 'audit/:id',
                    element: <AuditLogDetail />,
                    handle: {
                      crumb: () => 'Admin > Logs > Audit Log Details',
                    },
                  },
                  {
                    path: 'reviews-syncs',
                    element: <AdminReviewsSyncs />,
                    handle: {
                      crumb: () => 'Admin > Logs > Reviews synchronizations',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);
